import React from 'react';
import './MiniLoader.scss';

const MiniLoader = () => {
  return <div className="MiniLoader"></div>;
};

export default MiniLoader;
